import * as React from 'react';
import { Trans } from 'react-i18next';

import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { CircleIcon } from '@hotjar/webapp/components/CircleIcon';

interface Props {
  onFilterClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Container = styled.div`
  margin: ${tokens.spacer.x2} ${tokens.spacer.x3};
  display: flex;
`;

const IconContainer = styled.span`
  margin-top: ${tokens.spacer.x0};
  margin-right: ${tokens.spacer.x0};
`;

const MessageContainer = styled.div`
  font-size: 12px;
  margin-left: ${tokens.spacer.x0};
  color: ${tokens.color.text_light};
`;

const Button = styled.button`
  color: ${tokens.color.text_light};
  ${tokens.text('caption')}
  text-decoration: underline;
  cursor: pointer;
  margin: 0;
  border: none;
  padding: 0;
  outline: 0;
  background: transparent;
`;

export const Footer = ({ onFilterClick }: Props): JSX.Element => (
  <Container>
    <IconContainer>
      <CircleIcon
        backgroundColor={tokens.color.white}
        color={tokens.color.neutral_300}
        icon="info"
        size={20}
      />
    </IconContainer>
    <MessageContainer>
      <Trans i18nKey="common:recordings.segment-sidebar.fiter-your-recordings">
        <Button type="button" onClick={onFilterClick}>
          Filter your recordings
        </Button>{' '}
        and save them to create your own segments
      </Trans>
    </MessageContainer>
  </Container>
);
